import { IoChevronForwardCircleOutline } from "react-icons/io5";
import { LuPackageSearch } from "react-icons/lu";
import { BiReset } from "react-icons/bi";
import { FaBullhorn, FaLayerGroup } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import "../../../../styles.css";
import "../../../../slicer-styles.css";
import { RootState } from "../../../../store";
import { TRADE_SPEND_REPORT_TAB_ID } from "../../../../shared/constants";
import CheckboxDropdown from "../../../UI/CheckboxDropdown/CheckboxDropdown";
import { TradeSpendReportDropdownModel, TradeSpendReportSelectedSlicerModel } from "../../../../models/TradeAndPromoPlanning/TradeSpendReportSlicer.model";
import { tradeSpendReportTabAction } from "../../../../store/slices/trade-spend-report-tab-slice";
import { tradeAndPromoPlanningTabActions } from "../../../../store/slices/trade-and-promo-planning-tab-slice";
import { getDefaultSlicersForForecastEntryApp } from "../../../../shared/functions";
import RadioDropdown from "../../../UI/RadioDropdown/RadioDropdown";
import DropdownItem from "../../../../models/DropdownItem.model";

const TradeSpendReportSlicers = () => {
    // States
    const [isSlicerChanged, setIsSlicerChanged] = useState<boolean>(false);

    // Redux variables
    const dispatchFn = useDispatch();
    const slicers: TradeSpendReportDropdownModel = useSelector((state: RootState) => state.tradeSpendReportTab.slicers);
    const promotionType:any = [{name:'All', value:'All'}, {name:'Everyday', value: 'Everyday'}, {name:'Promotion', value: 'Promotion'}];
    const tempSelectedSlicers: TradeSpendReportSelectedSlicerModel = useSelector((state: RootState) => state.tradeSpendReportTab.tempSelectedSlicers);

    /**
     * Handler for applying selected slicers.
     * @param {Event} event Apply filters button click event.
     * @returns {void}
     */
    const applySelectedSlicers = (event: any): void => {
        const tempSlicers: TradeSpendReportSelectedSlicerModel = { ...tempSelectedSlicers };
        const selectedSlicers: TradeSpendReportSelectedSlicerModel = {
            skus: tempSlicers.skus.includes('All') ? ['All'] : tempSlicers.skus,
            brands: tempSlicers.brands.includes('All') ? ['All'] : tempSlicers.brands,
            promotions: tempSlicers.promotions.includes('All') ? ['All'] : tempSlicers.promotions,
            promotionType: tempSlicers.promotionType.includes('All') ? 'All' : tempSlicers.promotionType
        };
        dispatchFn(tradeSpendReportTabAction.setSelectedSlicers(selectedSlicers));
        dispatchFn(tradeAndPromoPlanningTabActions.setTabApiDataFetched({
            [TRADE_SPEND_REPORT_TAB_ID]: false
        }));
        setIsSlicerChanged(false);
    };

    /**
     * Handler for resetting selected slicers.
     * @param {Event} event Reset filters button click event.
     * @returns {void}
     */
    const resetSelectedSlicers = (event: any) => {
        const defaultSlicers: TradeSpendReportSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(TRADE_SPEND_REPORT_TAB_ID);

        if (
            tempSelectedSlicers.skus.toSorted().toString() !== defaultSlicers.skus.toSorted().toString() ||
            tempSelectedSlicers.brands.toSorted().toString() !== defaultSlicers.brands.toSorted().toString() ||
            tempSelectedSlicers.promotions.toSorted().toString() !== defaultSlicers.promotions.toSorted().toString() ||
            tempSelectedSlicers.promotionType.toString() !== defaultSlicers.promotionType.toString()
        ) {
            dispatchFn(tradeSpendReportTabAction.resetSelectedSlicers(null));
            dispatchFn(tradeAndPromoPlanningTabActions.setTabApiDataFetched({
                [TRADE_SPEND_REPORT_TAB_ID]: false
            }));
            setIsSlicerChanged(false);
        }
    };

    /**
     * Event handler for dropdown value change
     * @param {string} field Slicer field which was updated
     * @param {string} value Updated slicer value
     */
    const dropdownItemChangeHandler = (field: string, value: any) => {
        dispatchFn(tradeSpendReportTabAction.setTempSelectedSlicers({
            ...tempSelectedSlicers,
            [field]: value
        }));
        setIsSlicerChanged(true);
    }

    const promotionTypeChangeHandler = (value:any) => {
        dispatchFn(tradeSpendReportTabAction.setTempSelectedSlicers({
            ...tempSelectedSlicers,
            promotionType: value
        }));
        setIsSlicerChanged(true);
    }

    return (
        <>
            <CheckboxDropdown
                id="tsr-sku-dropdown"
                icon={<LuPackageSearch size={20} />}
                label="Product(s)"
                selectedValues={tempSelectedSlicers.skus.map((id: any) => id.toString())}
                items={slicers.skus}
                onItemChanged={(value: any) => dropdownItemChangeHandler("skus", value)}
            />

            <CheckboxDropdown
                id="tsr-brand-dropdown"
                icon={<LuPackageSearch size={20} />}
                label="Brand(s)"
                selectedValues={tempSelectedSlicers.brands}
                items={slicers.brands}
                onItemChanged={(value: any) => dropdownItemChangeHandler("brands", value)}
            />

            <CheckboxDropdown
                id="tsr-promotion-dropdown"
                icon={<FaBullhorn size={20} />}
                label="Promotion(s)"
                selectedValues={tempSelectedSlicers.promotions}
                items={slicers.promotions}
                onItemChanged={(value: any) => dropdownItemChangeHandler("promotions", value)}
            />

            <RadioDropdown
                    id="tsr-promotion-type-dropdown"
                    icon={<FaLayerGroup size={15} />}
                    label="Promotion Type"
                    selectedValue={tempSelectedSlicers.promotionType}
                    items={promotionType}
                    onItemChanged={(value: any) => promotionTypeChangeHandler(value)}
                    />

            <div className="d-inline me-1">
                <button type="button" className="btn btn-sm text-white" style={{ backgroundColor: "#00833E" }} onClick={applySelectedSlicers} disabled={!isSlicerChanged}>
                    <div className="d-flex justify-content-center align-items-center">
                        <IoChevronForwardCircleOutline size={20} /> &nbsp;Apply filters
                    </div>
                </button>
            </div>

            <div className="d-inline">
                <button type="button" className="btn btn-sm btn-warning" onClick={resetSelectedSlicers}>
                    <div className="d-flex justify-content-center align-items-center">
                        <BiReset size={20} /> &nbsp;Reset filters
                    </div>
                </button>
            </div>
        </>
    );
};

export default TradeSpendReportSlicers;
